export const ageFormattedNumberInputAttrs = {
  suffix: 'Jahr',
  suffixCallback: (numberVal: number) => {
    if (numberVal === 1) {
      return `${numberVal} Jahr`;
    }

    return `${numberVal} Jahre`;
  },
  maxDigits: 3,
};
